import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"

import Badge from "src/components/Badge"
import PreviewSheet from "src/components/PreviewSheet"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const JobTemplatePreview = ({ jobTemplate }) => {
  const { presentmentCurrency } = useMarina()
  const pricedByLength = (pricingStructure) => pricingStructure === "by_length"

  const lineItemLabel = (lineItem) => {
    let labelString = lineItem.product.name

    if (!pricedByLength(lineItem.product.pricingStructure)) {
      labelString += ` (${parseFloat(lineItem.quantity)})`
    }
    return labelString
  }

  const lineItemEstimatedCost = (lineItem) => {
    if (pricedByLength(lineItem.product.pricingStructure)) {
      return `auto · by ${lineItem.product.quantityUnitLabel}`
    }

    if (lineItem.subtotal === 0 || lineItem.subtotal === null) {
      return "-"
    }

    return formatCurrencyFromMinorUnits({
      amount: lineItem.subtotal,
      currency: presentmentCurrency,
    })
  }

  return (
    <PreviewSheet>
      <PreviewSheet.Trigger>
        <div className="flex max-w-[50px] flex-row items-center gap-1 hover:text-gray-600">
          {jobTemplate.lineItems.length}
          <i className="fa-kit fa-list text-lg"></i>
        </div>
      </PreviewSheet.Trigger>
      <PreviewSheet.Content>
        <div className="flex flex-col justify-center">
          {jobTemplate.lineItems.map((lineItem) => {
            const estimateDisplay = lineItemEstimatedCost(lineItem)
            return (
              <div className="flex justify-between" key={lineItem.id}>
                <div className="mr-5 flex items-center gap-2 text-gray-900">
                  <span
                    className={classNames({
                      "text-gray-400 line-through":
                        lineItem.product.active === false,
                    })}
                  >
                    {lineItemLabel(lineItem)}
                  </span>
                  {lineItem.product.active === false && (
                    <Badge color="red" text="Inactive" variant="small" />
                  )}
                </div>
                <div
                  className={classNames("text-sm text-gray-600", {
                    italic: pricedByLength(lineItem.product.pricingStructure),
                  })}
                >
                  {estimateDisplay}
                </div>
              </div>
            )
          })}
        </div>
      </PreviewSheet.Content>
    </PreviewSheet>
  )
}

JobTemplatePreview.propTypes = {
  jobTemplate: PropTypes.shape({
    lineItems: PropTypes.arrayOf(
      PropTypes.shape({
        productId: PropTypes.string.isRequired,
        quantity: PropTypes.string.isRequired,
        subtotal: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.oneOf([null]),
        ]),
        product: PropTypes.shape({
          name: PropTypes.string.isRequired,
          active: PropTypes.bool,
          quantityUnitLabel: PropTypes.string,
          pricingStructure: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.oneOf([null]),
          ]),
        }).isRequired,
      })
    ).isRequired,
  }).isRequired,
}

export default JobTemplatePreview
